import { render, staticRenderFns } from "./Missed.vue?vue&type=template&id=2fb15530"
import script from "./Missed.ts?vue&type=script&lang=ts&external"
export * from "./Missed.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports